export enum ProductType {
    TRAIL = 'TRAIL',
    SUBSCRIPTION = 'SUBSCRIPTION',
    ONE_MEAL_SERVICE = 'ONE_MEAL_SERVICE',
    STAR_CLEANER = 'STAR_CLEANER',
    CHEF_FOR_PARTY = 'CHEF_FOR_PARTY',
    BOOK_BY_DISH = 'BOOK_BY_DISH',
}
